import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedSettings } from '@shared/models/shared-settings';
import { MessageService } from '@shared/services/message-service';
import { interval, map, repeat, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ReloadService {

    constructor(private http: HttpClient, private settings: SharedSettings, private message: MessageService) {
        if (settings.buildNumber === '(debug build)')
            window['showReloadNotification'] = () => { this.Show(); };
    }

    Start() {
        if (this.settings.buildNumber === '(debug build)')
            return;

        interval(10 * 60 * 1000)
            .pipe(
                map(_ => Math.random()),
                switchMap(rand => this.http.get<{ version: string }>('/version.json?cachebust=' + rand)))
            .subscribe(updated => {
                if (updated.version !== this.settings.buildNumber) {
                    this.Show();
                }
            });
    }

    Show() {
        this.message.add({
            severity: 'info',
            summary: 'New Vision Update Available',
            detail: 'Please reload the application to receive the latest changes and avoid errors.',
            life: 10 * 60 * 1000,
            data: {
                button: {
                    action: () => location.reload(),
                    label: 'Reload Now'
                }
            }
        });
    }
}
